import React from 'react';

import AuthUserContext from './auth_user_context';
import { auth } from '../firebase/firebase';
import claimsObserver from './claims_observer';
import { connect } from 'react-redux';
import { getUser, setFirebaseInfo } from '../redux/actions/user-actions';

const mapStateToProps = (store) => {
  return {
    podcastUser: store.user.podcastUser,
    firebaseInfo: store.user.firebaseInfo
  };
};

const withAuthentication = (Component) =>
  connect(mapStateToProps)(
    class WithAuthentication extends React.Component {
      constructor(props) {
        super(props);

        this.state = {
          authUser: null,
          userStatus: null
        };
      }

      componentDidMount() {
        const { dispatch, podcastUser } = this.props;

        this.listener = auth.onAuthStateChanged((authUser) => {
          if (authUser) {
            authUser.getIdTokenResult().then((idTokenResult) => {
              this.setState({
                authUser,
                userStatus: idTokenResult.claims.userStatus
              });
            });

            var values = {};
            values.providerId = authUser.providerData[0].providerId;
            if (values.providerId === 'apple.com') {
              values.email = authUser.providerData[0].email;
              values.displayName = authUser.providerData[0].displayName;
            } else {
              values.email = authUser.email;
              values.name = authUser.displayName;
            }
            dispatch(setFirebaseInfo(values));

            if (!podcastUser) {
              authUser.getIdToken().then((token) => {
                dispatch(getUser(token));
              });
            }
          } else {
            this.setState({ authUser: null });
          }
        });

        this.claimsListener = (userStatus) => {
          this.setState({ userStatus });
        };
        claimsObserver.subscribe(this.claimsListener);
      }

      componentWillUnmount() {
        this.listener();
        claimsObserver.unsubscribe(this.claimsListener);
      }

      render() {
        const { authUser, userStatus } = this.state;

        return (
          <AuthUserContext.Provider value={{ authUser, userStatus }}>
            <Component {...this.props} />
          </AuthUserContext.Provider>
        );
      }
    }
  );

export default withAuthentication;
